import React from "react";
import { InputBlock } from "./styled";

const Input = ({
  type = "text",
  placeholder,
  value,
  setValueFunction,
  icon,
  altIconText = "text",
  clickIconFunction,
  isValid,
}) => {
  const handleOnInputChange = (e) => {
    setValueFunction(e.target.value);
  };

  console.log(isValid);

  return (
    <InputBlock>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => handleOnInputChange(e)}
        className={value.length === 0 ? "" : isValid ? "valid" : "invalid"}
      />
      <InputBlock.Icon onClick={clickIconFunction}>
        {value.length ? <img src={icon} alt={altIconText} /> : null}
      </InputBlock.Icon>
    </InputBlock>
  );
};

export default Input;
